export default class TextCalloutSections
{
  constructor() {
    this.$el = document.querySelector('.js-text-callout-sections')

    if (! this.$el) {
      return
    }

    this.$loadMoreButton = this.$el.querySelector('.js-load-more')
    this.$grid = this.$el.querySelector('.js-grid')

    if (! this.$loadMoreButton || ! this.$grid) {
      return
    }

    this.$loadMoreButton.addEventListener('click', this.loadMore.bind(this));
  }

  loadMore() {
    this.$grid.classList.add('done')
    this.$loadMoreButton.classList.add('hidden')
  }
}
